import { Directive } from '@angular/core';

@Directive({ selector: '[ggCustomPopupContent]' })
export class CustomPopupContentDirective {
  constructor() {}
}
